import axios from "axios";

const api = () => {
  const token = localStorage.getItem('SDC_USER_TOKEN')?.replace(/"/g, '');;
  const lang = localStorage.getItem('SDC_LANG')?.replace(/"/g, '');;

  const apiCall = axios.create({
    baseURL: 'https://api.sportdigitalclub.com/api/v1',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Accept-Language': `${lang}`,
    },
  })

  // Add a response interceptor
  apiCall.interceptors.response.use(
    (response) => {
      // If the response is successful, return the data as is
      return response;
    },
    (error) => {
      // If the error response status is 401 (Unauthenticated)
      if (error.response && error.response.status === 401) {
        // Clear user data from localStorage
        localStorage.removeItem("SDC_USER_TOKEN");
        localStorage.removeItem("SDC_USER");

        // Optionally, redirect the user to the login page
        window.location.href = "/auth/login";
      }

      // Return a rejected promise with the error object
      return Promise.reject(error);
    }
  );
  
  return apiCall
}

export default api